import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutCarrierSelection extends Layout {
    sourceRates: DataSource;
    tableRates: Table;
}
